export const UploaderErrors = {
  FILE_TYPE: "File type not supported",
  REQUIRED: "Uploading a file is required",
  UNSUPPORTED_FILE_TYPE: "File type not supported",
  FILE_SIZE: "File size exceeds limit",
  READING_ERROR: "Error reading file contents. See details:",
  PROCESSING_ERROR: "Error processing file. See details:"
} as const;
